import { useState, useEffect, useContext } from 'react';
import { oneOfType, bool, number, string, func, array } from 'prop-types';
import Flex from '../../shared/layouts/Flex';
import Box from '../../shared/layouts/Box';
import Display from '../../shared/Display';
import ArrowIcon from 'imagesUwKluis/svg/next_filled.svg';
import ConfirmedIcon from 'imagesUwKluis/svg/confirmed-filled.svg';
import theme from '../../../theme';
import { CompareContext } from './ComparePage';
import { useMediaQuery } from '@dnhb/node_package';
import { useTheme } from '@emotion/react';

const Compare = ({
  label,
  name,
  leftValue,
  rightValue,
  valueTransformer,
  leftToRight,
  onUpdate,
  gap,
  isCurrency,
  isPercentage,
  section,
}) => {
  const [diff, setDiff] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const { isFieldCopied } = useContext(CompareContext);
  const fieldIsCopied = isFieldCopied(`${section}-${name}`);

  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.md ?? '604px'})`);

  useEffect(() => {
    if (Array.isArray(leftValue) && Array.isArray(rightValue)) {
      setDiff(leftValue.some((value, i) => value !== rightValue[i]));
    } else if (leftValue == null && rightValue == null) {
      setDiff(false);
    } else {
      setDiff(leftValue !== rightValue);
    }
  }, [leftValue, rightValue]);

  const getDisplayVariant = (position) => {
    if (position === 'right') {
      if (fieldIsCopied) return 'succes';
      if (diff && !leftToRight) return 'active';
    } else {
      if (diff && leftToRight) return 'active';
    }
    return 'inactive';
  };

  const rightDisplayVariant = getDisplayVariant('right');
  const leftDisplayVariant = getDisplayVariant('left');

  return (
    <Flex
      onMouseEnter={() => setShowButton(true)}
      onMouseOver={() => setShowButton(true)}
      onMouseLeave={() => setShowButton(false)}
    >
      <Box flex={{ mobile: '0 0 45%', desktop: '1 1 50%' }}>
        <Display
          label={label}
          value={valueTransformer ? valueTransformer(leftValue) : leftValue}
          variant={leftDisplayVariant}
          isCurrency={isCurrency}
          isPercentage={isPercentage}
        />
      </Box>
      <Flex justifyContent="center" alignItems="flex-end" flexBasis={gap}>
        {fieldIsCopied && (
          <ConfirmedIcon
            fill={theme.colors.succes}
            width="24px"
            height="24px"
            css={{
              margin: isMobile ? '0 0 12px 0' : '12px',
            }}
          />
        )}
        {diff && showButton && !fieldIsCopied && (
          <ArrowIcon
            fill={theme.colors.primary}
            width="24px"
            height="24px"
            onClick={() =>
              onUpdate({
                target: {
                  value: leftToRight ? leftValue : rightValue,
                  name,
                },
              })
            }
            css={{
              transform: leftToRight ? '' : 'rotate(180deg)',
              cursor: 'pointer',
              margin: isMobile ? '0 0 12px 0' : '12px',
            }}
          />
        )}
      </Flex>
      <Box flex={{ mobile: '0 0 45%', desktop: '1 1 50%' }}>
        <Display
          label={label}
          value={valueTransformer ? valueTransformer(rightValue) : rightValue}
          variant={rightDisplayVariant}
          isCurrency={isCurrency}
          isPercentage={isPercentage}
        />
      </Box>
    </Flex>
  );
};

Compare.propTypes = {
  leftValue: oneOfType([bool, number, string, array]),
  rightValue: oneOfType([bool, number, string, array]),
  name: string.isRequired,
  label: string,
  onUpdate: func,
  leftToRight: bool,
  gap: string,
  isCurrency: bool,
  isPercentage: bool,
};

Compare.defaultProps = {
  leftValue: '',
  rightValue: '',
  leftToRight: false,
  onUpdate: () => {},
  label: '',
  gap: '100px',
  isCurrency: false,
  isPercentage: false,
};

export default Compare;
